import { Box, Text } from '@chakra-ui/react';
import { useBinderCardColors } from '../../binder_report/hooks/useBinderCardColors';
import type { MortgageeWithStatus } from '../types';

interface MortgageeDisplayProps {
  mortgagee: MortgageeWithStatus;
  showRemark?: boolean;
  showNonStandardHighlight?: boolean;
}

const MortgageeDisplay = ({
  mortgagee,
  showRemark = true,
  showNonStandardHighlight = true,
}: MortgageeDisplayProps) => {
  const colors = useBinderCardColors();

  const addressParts = [
    mortgagee.address,
    mortgagee.city,
    mortgagee.provinceCode,
    mortgagee.postalCode,
  ].filter(Boolean);
  const fullAddress = addressParts.join(', ');

  const isHighlighted = showNonStandardHighlight && mortgagee.isNonStandard;

  return (
    <Box>
      <Text
        color={isHighlighted ? 'red.500' : colors.textColor}
        fontWeight="semibold"
        fontSize="sm"
      >
        {mortgagee.name}
      </Text>
      {fullAddress && (
        <Text color={colors.descriptionColor} fontSize="xs" mt={0.5}>
          {fullAddress}
        </Text>
      )}
      {showRemark && mortgagee.remark && (
        <Box
          mt={1.5}
          px={2}
          py={1}
          bg="blue.50"
          borderRadius="sm"
          borderLeftWidth="2px"
          borderLeftColor="blue.400"
        >
          <Text fontSize="xs" color="blue.700">
            <Text as="span" fontWeight="semibold">
              Remark:{' '}
            </Text>
            {mortgagee.remark}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default MortgageeDisplay;
